<script>

    import State from '../stores/State.js';

    export let started = $State.started;

    let winW = 960;
    let w = 960;
    
//    const isChrome = navigator.userAgent.includes("Chrome") && navigator.vendor.includes("Google Inc");
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isIPadOS = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
    const disableImgClip = isSafari && !isIPadOS;

	let sound = new Audio('/audio/raceby-start.mp3');

    function playSound() {
        sound.currentTime = 0
        sound.play();
    }
    function setStarted() {
        started = true;
    }

    $: $State.started = started;

</script>

<svelte:window bind:innerWidth={winW}/>

<div>
    <section id="titleScreen">

        <img class='backImg' src='/images/redbull-hero.png' alt="Red Bull F1 Car"/>
        {#if !started}
            <div class="startup">
                <div>
                    This site has sound.<br>
                    Put some headphones on and<br>
                    <button class="btn startBtn" on:click="{() => {playSound(); setStarted();}}">Get Started</button>
                </div>
            </div>
        {:else}
            <svg class="svg-defs"viewBox="0 0 {winW > 960 ? w : 960} 960">
                <clipPath id="clipping-with-text" transform="scale({winW > 960 ? 1 : winW/960})">
                    <text class="titleText" x="50%" y="27%">THUNDER</text> 
                    <text class="titleText" x="50%" y="43%">ROADS</text>  
                </clipPath>
            </svg>
            
            {#if !disableImgClip}    
                <div class="clipDiv" bind:clientWidth={w}>
                    <img src="/images/redbull-hero.png" alt="Red Bull F1 Car" />
                </div>
            {/if}
            <svg class="textOutline" viewBox="0 0 960 960" >
                <text class="titleText" style="{disableImgClip ? 'fill:black;' : ''}" x="50%" y="27%">THUNDER</text> 
                <text class="titleText" style="{disableImgClip ? 'fill:black;' : ''}" x="50%" y="43%">ROADS</text> 
            </svg>
            
            <div class='titleSpacer'></div>

            <div class='subs'>        
                <div class='subtitle'>Lightning Races, Finish Traces, & Championship Places</div>
                <div class='hrule'>in the</div>
                <div class='subtitle pink'>2021 Formula One Season</div>
            </div>
        {/if}
    </section>
</div>

<style>

    .backImg {
        position: absolute;
        display: block;
        opacity: 0.2;
        left: 0;
        right: 0;
        margin: 0 auto;
        z-index: -1;
        max-width: 100vw;
    }

    .textOutline {
        position: absolute;
        display: block;
        left: 0;
        right: 0;
        margin: 0 auto;
        z-index: -1;
        max-width: 100vw;
        opacity: 0.9999;
        z-index: 999999;
        overflow: visible;
        width: 960px;
        max-width: 100vw;
    }

    .textOutline text{
        fill: none;
        stroke: #FF285D;
        stroke-width: 3;
    }

    .clipDiv {
        position: absolute;
        display: block;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 100%;
        background-color: black;
        clip-path: url(#clipping-with-text);
        -webkit-clip-path: url(#clipping-with-text);
    }

    .clipDiv img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 100vw;
    }

    .svg-defs {
        position: absolute;
        width: 0;
        height: 0;
    }


    #titleScreen {
        min-height: 100vh;
        height: 960px;
    }



    .hrule {
        overflow: hidden;
        text-align: center;
        text-transform: uppercase;
    }

    .hrule:before,
    .hrule:after {
        background-color: #ccc;
        content: "";
        display: inline-block;
        height: 1px;
        position: relative;
        vertical-align: middle;
        width: 28%;
        max-width: 340px;
    }

    .hrule:before {
        right: 0.5em;
        margin-left: -50%;
    }

    .hrule:after {
        left: 0.5em;
        margin-right: -50%;
    }


    .titleText {
        font-family: 'Poppins', 'Century Gothic', sans-serif;
        font-style: italic;
        font-weight: 800;
        font-size: 200px;
        text-anchor: middle;
        text-transform: uppercase;
        letter-spacing: -0.05em;
        dominant-baseline: middle;
        animation-name: textIntro;
        animation-duration: 3s;
        animation-timing-function: ease-in-out;
    }


    @keyframes textIntro {
        0%   {font-size: 2200px; }
        100%   {font-size: 200px; }
    }

    @keyframes subtextIntro {
        0%   {transform: scale(0.1); opacity: 0;}
        50%   {transform: scale(0.1); opacity: 0;}
        100%   {transform: scale(1); opacity: 1;}
    }

    .titleSpacer {
        height: 530px;
        max-height: 55vw;
    }

    .subs {
        font-family: 'Poppins', 'Century Gothic', sans-serif;
        position: absolute;
        display: block;
        left: 0;
        right: 0;
        margin: 0 auto;
        font-family: 'Poppins', 'Century Gothic', sans-serif;
        z-index: 2;
        animation-name: subtextIntro;
        animation-duration: 4s;
        animation-timing-function: ease-out;
    }

    .subtitle {
        font-style: italic;
        font-weight: 800;
        font-size: 32px;
        line-height: 36px;
        letter-spacing: 0.03em;
        text-align: center;
        text-transform: uppercase;
        color: white;
        vertical-align: middle;
        margin: 0;
    }

    @media screen and (max-width: 1080px) {
        .subtitle {
            font-size: 28px;;
        }
    }

    @media screen and (max-width: 600px) {
        .subtitle {
            font-size: 24px;;
        }
        #titleScreen {
            height: auto;
            min-height: 80vh;
        }
        .clipDiv {
            display: none;
        }
        .textOutline text{
            fill: black;
        }
    }

    .pink {
        color: #FF285D;
    }
    
    /* .closekern {
        letter-spacing: -.12em;
    }
    .farkern {
        letter-spacing: -.08em;
    } */

    .startup {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        padding-left: 15px;
        font-size: 20px;
        box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 1);

    }

    @media screen and (max-width: 700px) {
        .startup {
            height: 70vh;
        }
    }

    .startBtn {
        background: linear-gradient(96.45deg, #FF8392 0%, #FF285D 100%);
        color: black;
        font-family: 'Poppins', 'Century Gothic', sans-serif;
        font-weight: 700;
        font-style: italic;
        padding: 10px 30px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-size: 16px;
    }


   
    .btn {
        display: inline-block;
        margin-top: 15px;
        margin-bottom: 0;
        border-radius: 99px;
        border: 1px solid #343135;
        background-color: #00000000;
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000;
        background-repeat: no-repeat;
        background-position: center;
        position: relative;
        -webkit-appearance: none;
    }
    


    .btn:hover {
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000, 0 0 0 2px #FF285D;
    }

    .btn:active {
        box-shadow: inset 1px 2px 2px rgba(0, 0, 0, 0.8), inset -1px -1px 2px rgba(255, 255, 255, 0.5);
        background-color: #00000000;
    }
</style>